import React, { memo, useMemo, useCallback } from 'react';
import styles from 'assets/css/HelpOverlay.module.css';
import { IconAngleRightBold, IconQuestionMarkCircle, IconCloseBold }  from '@ace/react-icons';
import { useOverlayToggle } from '@ace/react-utilities';
import { DashboardVariantID } from 'Components/Dashboard/DashboardHelper';

export default function HelpOverlay(props) {
    const { showOverlay, toggleOverlay, overlayRef } = useOverlayToggle();
    const handleToggleClick = useCallback(() => {
        toggleOverlay();
    }, [toggleOverlay]);

    const OverlayLaunchBtn = useMemo(
        () => (
            <div className={styles.helpOverlayLaunchBtn} onClick={() => handleToggleClick()}>
                <IconQuestionMarkCircle />
            </div>
        ), [handleToggleClick]
    );

    return (

        <div className={styles.helpOverlayOuter}>
            {OverlayLaunchBtn}
            {showOverlay ? <OverlayContent toggleOverlay={handleToggleClick} ref={overlayRef} /> : false}
        </div>
    )
}

const OverlayContent = React.forwardRef((props, ref) => {
    const { toggleOverlay } = props;

    return (
        <div className={styles.helpOverlayBackground}>
            <div ref={ref} className={styles.helpOverlayContent}>
                <div className={styles.helpOverlayCloseBtn} onClick={() => toggleOverlay()}>
                    <IconCloseBold />
                </div>
                <h2 className={styles.helpOverlayTitle}>
                    Help &amp; Support
                </h2>
                <ul className={styles.helpOverlayItems}>
                    {useMemo(() => (getOverlayItems(DashboardVariantID)), [])}
                </ul>
            </div>
        </div>
    );
});

const OverlayListItem = (props) => {
    const { headerText, linkHref, linkText, linkNoWrapText, isBlank } = props;

    const target = isBlank ? "_blank" : "";
    const rel = isBlank ? "noreferrer noopener" : "";

    return (
        <li className={styles.helpOverlayItem}>
            <h4 className={styles.helpOverlayItemHeading}>
                {headerText}
            </h4>

            <a href={linkHref} className={`ace-btn-stroke--reversed ${styles.helpOverlayItemButton}`} target={target} rel={rel}>
                {linkText}
                <span className={"text-wsp-nowrap"}>
                    &nbsp;{linkNoWrapText}
                    <IconAngleRightBold />
                </span>
            </a>
        </li>
    );
}

const OverlayItemSalesContact = memo(
    () => {
        const overlayListItemProps = {
            headerText: "Need help with a purchase?",
            linkHref: "tel:8888253636",
            linkText: "Call",
            linkNoWrapText: "(888) 825-3636",
            isBlank: false
        };

        return (
            <OverlayListItem {...overlayListItemProps} />
        );
    }
);

const OverlayItemStudySupportAdv = memo(
    () => {
        const overlayListItemProps = {
            headerText: "Need study support?",
            linkHref: "tel:8885199845",
            linkText: "Call",
            linkNoWrapText: "888-519-9845",
            isBlank: false
        };

        return (
            <OverlayListItem {...overlayListItemProps} />
        );
    }
);

const OverlayItemStudySupport = memo(
    () => {
        const overlayListItemProps = {
            headerText: "Need study support?",
            linkHref: "/fitness-certifications/ace-answers/",
            linkText: "Check Out",
            linkNoWrapText: "ACE Answers",
            isBlank: true
        };

        return (
            <OverlayListItem {...overlayListItemProps} />
        );
    }
)

const OverlayItemExamReg = memo(
    () => {
        const overlayListItemProps = {
            headerText: "Need help with exam registration?",
            linkHref: "tel:8885199846",
            linkText: "Call",
            linkNoWrapText: "(888) 519-9846",
            isBlank: false
        };

        return (
            <OverlayListItem {...overlayListItemProps} />
        );
    }
);

const OverlayItemsAdvantage = memo(
    () => (
        <>
            <OverlayItemSalesContact/>

            <OverlayItemStudySupportAdv />

            <OverlayItemExamReg />
        </>
    )
);

const OverlayItemsDefault = memo(
    () => (
        <>
            <OverlayItemSalesContact />

            <OverlayItemStudySupport />

            <OverlayItemExamReg />
        </>
    )
);

const getOverlayItems = (variantID) => {
    switch (variantID) {
        case 1:
            return <OverlayItemsAdvantage />;
        default: 
            return <OverlayItemsDefault />;
    }
}
